var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-btn',_vm._b({on:{"click":function($event){return _vm.$emit("click", $event)}}},'b-btn',_vm.$attrs,false),[(!_vm.loading)?_vm._t("default"):_c('div',[_c('i',{staticClass:"fas fa-spinner fa-spin"})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }